<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width no-wrap"
      :style="{ height: '76px' }"
    >
      <span
        class="text-lg text-neutral text-weight-medium"
        :style="{ maxWidth: '75%' }"
      >
        {{ heading }}
      </span>

      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>
    <q-separator color="neutral-40 q-mx-xl" />
    <div class="q-px-2x-md q-py-xl col overflow-auto">
      <q-linear-progress v-if="loading" indeterminate />
      <PTimeline v-else>
        <div v-if="!timelines?.length">No activity yet!</div>
        <PTimelineEntry v-for="(timeline, index) in timelines" :key="index">
          <template #default>
            <div class="text-weight-regular text-sm">
              {{ timeline.description || "-" }}
            </div>
            <div class="text-weight-regular text-xs text-neutral-70">
              {{ formatDate(timeline.event_time, "DD MMM YYYY, h:mm a") }}
            </div>
          </template>
        </PTimelineEntry>
      </PTimeline>
    </div>
  </div>
</template>

<script setup>
import { date } from "quasar";
import CloseIcon from "assets/icons/close.svg";

const { formatDate } = date;

const timelines = ref([]);

const { timelinesDrawerState } = storeToRefs(useAuditLogsStore());
const { getAuditLogs, toggleTimelinesDrawer } = useAuditLogsStore();

const props = defineProps({
  entityId: {
    type: String,
    default: () => "",
  },
  entityName: {
    type: String,
    default: () => "",
  },
  heading: {
    type: String,
    default: () => "Timelines",
  },
  action: {
    type: String,
    default: () => "",
  },
});

const loading = ref(false);

const onClose = () => {
  toggleTimelinesDrawer({
    open: false,
  });
};

watch(
  () => unref(timelinesDrawerState).open,
  async (open) => {
    if (open) {
      const params = {
        entity_id: props.entityId,
        entity: props.entityName,
        action: props.action,
      };

      loading.value = true;

      const response = await getAuditLogs({ params });

      timelines.value = response?.data?.data?.data;

      loading.value = false;
    }
  },
  {
    immediate: true,
  },
);
</script>
